import { render, staticRenderFns } from "./CopyrightAssignmentTransferEscalationFile.vue?vue&type=template&id=aca5ac18&scoped=true&"
import script from "./CopyrightAssignmentTransferEscalationFile.vue?vue&type=script&lang=js&"
export * from "./CopyrightAssignmentTransferEscalationFile.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAssignmentTransferEscalationFile.vue?vue&type=style&index=0&id=aca5ac18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca5ac18",
  null
  
)

export default component.exports